import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-41">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-4 left-0 right-0 z-50 px-3 md:px-4" style={{
      background: 'linear-gradient(to top, rgba(245,237,228,1) 60%, rgba(245,237,228,0))'
    }} data-id="element-42">
          <div className="max-w-lg mx-auto" data-id="element-43">
            <a href="https://homemasterglobal.com/cart/43531718492238:1" target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center font-bold md:text-base py-4 px-6 rounded-full transition-all duration-300 whitespace-nowrap no-underline text-[15px] gap-[8px]" style={{
          backgroundColor: '#e76f51',
          color: '#ffffff',
          boxShadow: '0 4px 20px rgba(231,111,81,0.4)'
        }} onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#f08565';
          e.currentTarget.style.transform = 'scale(1.02)';
        }} onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = '#e76f51';
          e.currentTarget.style.transform = 'scale(1)';
        }} data-id="element-44">
              Sí, quiero dominar el Método — $6.39 USD
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}